import { render, staticRenderFns } from "./TicketStatusView.vue?vue&type=template&id=64efb1a2&scoped=true&"
import script from "./TicketStatusView.vue?vue&type=script&lang=ts&"
export * from "./TicketStatusView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64efb1a2",
  null
  
)

export default component.exports